/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// Support component names relative to this directory:

import "babel-polyfill"

var componentRequireContext = require.context("components", true)
window.componentRequireContext = componentRequireContext
var ReactRailsUJS = require("react_ujs")
ReactRailsUJS.useContext(componentRequireContext)

var BookingGuest = require("../BookingGuest.js")
global.BookingGuest = BookingGuest.default;

var HomeIntro = require("../HomeIntro.ts");
global.HomeIntro = HomeIntro.default;

require("../legacy/advert_detail_block")
import 'moment/locale/nl'
import 'moment/locale/fr'
import 'moment/locale/de'
import * as moment from 'moment';
moment.locale(Gites.locale)

import * as nl from 'react-intl/locale-data/nl';
import * as fr from 'react-intl/locale-data/fr';
import * as de from 'react-intl/locale-data/de';
import { addLocaleData } from "react-intl"
addLocaleData([...nl])
addLocaleData([...fr])
addLocaleData([...de])
import 'whatwg-fetch'
